import { useSession } from "next-auth/react";
import { SessionNextAuthUser } from "../user/types/user.types";
import { encodeToken } from "./auth.func";

export const useGetSession = () => {
  const { data, status } = useSession();
  const userSession = data as SessionNextAuthUser;

  const isUserConnected = userSession?.user?.email;
  const isUserSubscribed = Boolean(userSession?.user?.company?.customer);
  const isUserAdmin = userSession?.user?.role === "admin";
  const appToken = userSession?.user?.company?.appToken;

  return {
    isUserConnected,
    isUserSubscribed,
    userSession,
    appToken,
    isUserAdmin,
  };
};
